/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Filter_All_GrowersInputs */

const vi_care_log_filter_all_growers = /** @type {(inputs: Care_Log_Filter_All_GrowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả hộ`)
};

/**

* @param {Care_Log_Filter_All_GrowersInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_filter_all_growers = /** @type {((inputs?: Care_Log_Filter_All_GrowersInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Filter_All_GrowersInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_filter_all_growers(inputs)
});